import { render, staticRenderFns } from "./ConfigWebsiteCatalogueArticleDetails.vue?vue&type=template&id=72ca60ea"
import script from "./ConfigWebsiteCatalogueArticleDetails.vue?vue&type=script&lang=js"
export * from "./ConfigWebsiteCatalogueArticleDetails.vue?vue&type=script&lang=js"
import style0 from "./ConfigWebsiteCatalogueArticleDetails.vue?vue&type=style&index=0&id=72ca60ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports